import APIclient from "API/Client";
import { GetOrgId } from "utility";

export const getAccountingTag = () => {
  return APIclient.getData(`/ms/b2b-accounting/v2/partners/trackingCategories`, "", false, {
    headers: { "X-Organisation-Id": GetOrgId() },
  });
};
